var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"border border-alto w-8 h-8 font-bold rounded-sm text-xl flex items-center justify-center focus:outline-none hover:bg-primary hover:text-white",attrs:{"type":"button"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }